<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <!-- Section des informations générales -->
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
            
            <router-link
              to="/paiements/liste-paiements"
              class="btn btn-primary transition border-0 lh-1 fw-medium"
            >
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour
            </router-link>
          </div>

          <div class="row mb-4">
            <div class="col-md-3">
              <p class="fw-bold mb-1">Date de Paiement :</p>
              <p>{{ format_Date(paiement?.datePaiement) || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Montant Payé :</p>
              <p>{{ paiement?.montantPaye || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Montant Restant :</p>
              <p>{{ paiement?.montantRest || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Reliquat :</p>
              <p>{{ paiement?.reliquat || 'N/A' }}</p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-3">
              <p class="fw-bold mb-1">Référence Opération :</p>
              <p>{{ paiement?.refOperation || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Numéro Mobile :</p>
              <p>{{ paiement?.numeroMobileMoney || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Mode de Paiement :</p>
              <p>{{ paiement?.modepaiement?.libelle || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Facture :</p>
              <p>{{ paiement?.facture || 'N/A' }}</p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-3" v-if ="paiement?.modepaiement?.id === 4">
              <p class="fw-bold mb-1">Numéro de Virement :</p>
              <p>{{ paiement?.numeroVirement || 'N/A' }}</p>
            </div>
            <div class="col-md-3" v-if ="paiement?.modepaiement?.id === 3">
              <p class="fw-bold mb-1">Numéro de Chèque :</p>
              <p>{{ paiement?.nomCheque || 'N/A' }}</p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-3">
              <p class="fw-bold mb-1" v-if="paiement?.modepaiement?.id === 3 || paiement?.modepaiement?.id === 4">Banque :</p>

              <p>{{ paiement?.banque?.denominationBanque || 'N/A' }}</p>
            </div>  
            <div class="col-md-3">
              <p class="fw-bold mb-1">Commande :</p>
              <p>{{ paiement?.commande?.refCom || 'N/A' }}</p>
            </div>
            <div class="col-md-3">
              <p class="fw-bold mb-1">Montant TTC :</p>
              <p>{{ paiement?.montantDu || 'N/A' }}</p>
            </div>
          </div>

          <!-- Section Billetage pour paiement en espèces -->
          <div v-if="paiement?.modepaiement?.id === 1" class="card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25">
  <h5 class="fw-bold text-black mb-15 mb-md-25">Billetage</h5>
  <div class="row">

    <!-- Encaissement -->
    <div class="col-md-6">
      <h6 class="fw-bold text-black mb-10">Encaissement</h6>
      <table class="table">
        <thead>
          <tr>
            <th>Monnaie</th>
            <th>Quantité</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(billetage, index) in paiement?.billetages.filter(b => b.sens === 'ENTREE')" 
            :key="index"
          >
            <td>{{ billetage?.libelle || 'N/A' }}</td>
            <td>{{ billetage?.qteBillet || 'N/A' }}</td>
            <td>{{ billetage?.montant || 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
      <p class="fw-bold mt-10">
        Total Encaissement : {{ paiement?.montantTotalEncaissement || 'N/A' }} Fcfa
      </p>
    </div>

    <!-- Reliquat (Sortie) -->
    <div class="col-md-6">
      <h6 class="fw-bold text-black mb-10">Reliquat</h6>
      <table class="table">
        <thead>
          <tr>
            <th>Monnaie</th>
            <th>Quantité</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(billetage, index) in paiement?.billetages.filter(b => b.sens === 'SORTIE')" 
            :key="index"
          >
            <td>{{ billetage?.libelle || 'N/A' }}</td>
            <td>{{ billetage?.qteBillet || 'N/A' }}</td>
            <td>{{ billetage?.montant || 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
      <p class="fw-bold mt-10">
        Total Reliquat : {{ paiement?.montantTotalSortie || 'N/A' }} Fcfa
      </p>
    </div>

  </div>
</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils";
import { useRoute } from "vue-router";
import { Paiement } from "@/models/Paiement";

export default defineComponent({
  name: "ViewPaiement",
  setup: () => {
    const route = useRoute();
    const paiement = ref<Paiement | null>(null);

    function getPaiement(id: string) {
      return ApiService.get(`/paiements/${id}`)
        .then(({ data }) => {
          console.log("donnee:", data);
          paiement.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    onMounted(() => {
      const id = route.params.id as string;
      getPaiement(id);
    });

    return {
      paiement,
      getPaiement,
      format_Date,
    };
  },
});
</script>